import { d as n } from "../../vendor-Dd6qj6gJ.js";
import "react/jsx-runtime";
import "react";
import { getSpacingClasses as m } from "../../utils/getSpacingClasses/index.js";
import '../../assets/index10.css';const a = "_baseButton_4vskd_1", i = "_sm_4vskd_28", v = "_md_4vskd_33", p = "_primary_4vskd_39", u = "_secondary_4vskd_53", k = "_ghost_4vskd_54", y = "_destructive_4vskd_81", s = {
  baseButton: a,
  sm: i,
  md: v,
  primary: p,
  secondary: u,
  ghost: k,
  destructive: y
}, l = ({ size: t, variant: o, m: _, mt: d, mr: c, mb: r, ml: e }) => n(
  s.baseButton,
  t ? s[t] : void 0,
  o ? s[o] : void 0,
  m({ m: _, mb: r, ml: e, mr: c, mt: d })
);
export {
  l as getButtonStyles
};
